<template>
  <div class="lucky-wheel-container">
    <!-- 顶部导航栏 -->
    <van-nav-bar
      left-arrow
      @click-left="$router.push('/')"
      class="nav-bar"
    >
      <template #title>
        <van-image class="logo" :src="require('@siteResources/logo/home_logo.png')" />
      </template>

      <template #right>
        <div class="record-btn" @click="showRecordPopup = true">抽奖记录</div>
      </template>
    </van-nav-bar>

    <!-- 主标题 -->
    <div class="main-title">
      <img :src="require('@/assets/images/luckyWheel/bigTitle.png')" class="big-title" />
      <div class="subtitle">100%中奖 最高赢取{{ luckyWheelData?.issue_money }}</div>
<!--      <div class="user-info">-->
<!--        <span>用户09870987 抽中了 38.88</span>-->
<!--        <span class="countdown">3分钟前</span>-->
<!--      </div>-->

      <div class="records-info">
        <div class="records-info-inner">
          <MyScroll
              v-if="recordsMarquee.length"
              :data="recordsMarquee"
              :duration="2000"
          />
        </div>
      </div>
    </div>

    <!-- 转盘游戏区域 -->
    <div class="wheel-container">
      <div class="wheel-wrapper">
        <div class="wheel-prizes" ref="wheelRef">
          <!-- 9个奖品格子 -->
          <div
            v-for="(prize, index) in prizes"
            :key="index"
            class="prize-item"
            :class="{'prize-active': currentPrizeIndex === index, 'center-item': prize.type === 'text' }"
            :style="getPrizeStyle(index)"
          >
            <div class="prize-content">
              <template v-if="prize.type !== 'text'">
                <img v-if="prize.type == 2 " :src="require('@/assets/images/luckyWheel/prizeIcon.png')" class="coin-icon" alt="金币" />
                <img v-else :src="prize.img_path" class="coin-icon" alt="金币" />
                <div class="prize-amount">{{ prize.content }}</div>
              </template>
              <template v-else>
                <div class="prize-text">
                  <div>
                    当前<span>{{ luckyWheelData.member_count }}</span>次
                  </div>
                  <div>抽奖机会</div>
                </div>
              </template>
            </div>
          </div>
        </div>

        <!-- 抽奖按钮 -->
        <div class="draw-button" @click="startLuckyDraw"></div>
      </div>
    </div>

    <!-- 抽奖规则说明 -->
    <div class="rules-container">
      <div class="rules-title">如何获得抽奖机会</div>
      <div class="rules-content">
        <p>单笔充值{{ luckyWheelData?.recharge_config?.min_recharge_amount ?? 0 }}以上即可获得一次抽奖机会（每日{{ luckyWheelData?.recharge_config?.day_number ?? 0 }}次）</p>
        <p>单笔提现{{ luckyWheelData?.withdrawal_config?.min_withdrawal_amount ?? 0 }}以上即可获得一次抽奖机会（每日{{ luckyWheelData?.withdrawal_config?.day_number ?? 0 }}次）</p>
        <p>成功卖币{{ luckyWheelData?.sell_config?.min_sell_amount ?? 0 }}即可获得一次抽奖机会（每日{{ luckyWheelData?.sell_config?.day_number ?? 0 }}次）</p>
        <p v-if="luckyWheelData?.winning_day">（抽奖次数仅{{ luckyWheelData?.winning_day ?? 0 }}天有效期，请及时抽奖！）</p>
        <p class="tips">充值=充值至平台，提现=平台提现至钱包</p>
      </div>

      <div class="rules-title">温馨提示</div>
      <div class="rules-content">
        <p>在订单高峰期时间段 （<span v-for="(item, index) in luckyWheelData?.winning_date_config || []" :key="index">
            <span>{{ `${item.start_date}~${item.end_date}` }}</span>点
          </span>）
        </p>
        <p>每个时间段均有双倍大奖概率</p>
        <p>祝您好运连连，旗开得胜！</p>
      </div>
    </div>

    <!-- 抽奖记录弹框 -->
    <van-dialog
      v-model:show="showRecordPopup"
      title="抽奖记录"
      class="record-dialog"
      :show-confirm-button="false"
      :close-on-click-overlay="true"
    >
      <div class="table-header">
        <span>用户名称</span>
        <span>中奖内容</span>
        <span>中奖数量</span>
        <span>中奖时间</span>
      </div>

      <div class="record-list">
        <van-list
            v-model:loading="loadingMore"
            :finished="finishedMore"
            finished-text="没有更多了"
            @load="onLoadMore"
            :immediate-check="false"
        >
          <div class="record-item" v-for="(record, index) in records" :key="index">
            <span class="username">{{ record.username }}</span>
            <span>{{ record.type === 2 ? '现金' : record.content }}</span>
            <span>{{ record.type === 2 ? record.content : 1 }}</span>
            <span>{{ record.created_at }}</span>
          </div>
        </van-list>
      </div>

      <van-empty
          v-if="records.length === 0"
          class="custom-image"
          :image="require('@/assets/images/luckyWheel/imgEmpty.png')"
          description="暂无数据～"
      />
    </van-dialog>
  </div>
</template>

<script setup>
import {ref, onBeforeUnmount, computed, watch} from 'vue';
import { getLuckyWheel, luckyWheelPlayHistory, luckyWheelPlay, luckyWheelPlayHistory2 } from '@/api/api'
import { Toast } from "vant";
import { useStore } from 'vuex'
import { useRouter } from "vue-router";
import MyScroll from './ScrollMarquee'
import { formatTime } from '@/utils'

const $router = useRouter()
const store = useStore()

const themeImgs = computed(() => store.state.themeImgs)

// 跑马灯数据
const recordsMarquee = ref([]);

const getLuckyWheelPlayHistory2 = () => {
  luckyWheelPlayHistory2({ aid: luckyWheelData.value.id }).then(res => {
    if (res.result === 200000 && res.data.list && res.data.list.length) {
      recordsMarquee.value = res.data.list
    }
  })
}

const luckyWheelData = ref({})
// 奖品列表
const prizes = ref([]);

getLuckyWheel().then(res => {
  if (res.result === 200000 && res.data.list.length) {
    luckyWheelData.value = res.data.list[0]

    getLuckyWheelPlayHistory2()
    prizes.value = luckyWheelData.value?.prize_config
    prizes.value?.splice(4, 0, { type: 'text', text: '当前次数抽奖机会' })
  } else {
    Toast(`活动已结束，敬请期待`)
    $router.push('/')
  }
})

// 当前选中的奖品索引
const currentPrizeIndex = ref(-1);
// 是否正在抽奖
const isDrawing = ref(false);
// 转盘旋转角度
const rotationDegree = ref(0);
// 动画定时器
const timer = ref(null);

// 获取奖品样式，根据索引计算位置
const getPrizeStyle = (index) => {
  // 3x3网格布局
  const row = Math.floor(index / 3);
  const col = index % 3;
  return {
    gridRow: `${row + 1} / ${row + 2}`,
    gridColumn: `${col + 1} / ${col + 2}`,
  };
};

const playResult = ref({})

// 开始抽奖
const startLuckyDraw = async () => {
  if (isDrawing.value) return;

  isDrawing.value = true;

  // 模拟随机选中一个奖品
  // const randomIndex = Math.floor(Math.random() * prizes.value.length);

  // 设置动画参数
  let speed = 0;
  let acceleration = 0.3;
  let maxSpeed = 20;
  let slowDownIndex = 10; // 开始减速的时间点
  let count = 0;
  let targetIndex = 0;

  const { result, data, msg } = await luckyWheelPlay({ aid: luckyWheelData.value.id })

  if (result === 200000) {
    playResult.value = data.list;
    // playResult.value =     {
    //   "seat": 4,
    //   "type": '1',
    //   "content": "888"
    // };

    // 因为下标为4的位置被“当前抽奖次数”占位了，所以从4开始， 下标都要加1
    const position = playResult.value.seat;
    targetIndex = position < 4 ? position : position + 1;

    // 定义顺时针转动顺序
    const clockwiseOrder = [0, 1, 2, 5, 8, 7, 6, 3];
    // let currentOrderIndex = clockwiseOrder.indexOf(currentPrizeIndex.value);
    // if (currentOrderIndex === -1) currentOrderIndex = 0;
    let currentOrderIndex = -1;

    // 清除之前的定时器
    if (timer.value) {
      clearInterval(timer.value);
    }

    // 开始旋转动画
    timer.value = setInterval(() => {
      count++;

      // 加速阶段
      if (count < 15) {
        speed += acceleration;
        if (speed > maxSpeed) speed = maxSpeed;
      }

      // 匀速阶段
      else if (count < slowDownIndex) {
        speed = maxSpeed;
      }

      // 减速阶段
      else {
        speed -= acceleration * 0.8;
        if (speed < 0.5) {
          speed = 0.5;
        }

        // 当速度很慢且接近目标奖品时停止
        if (speed < 2 && currentPrizeIndex.value === targetIndex) {
          clearInterval(timer.value);
          isDrawing.value = false;

          if (luckyWheelData.value.member_count > 0) {
            luckyWheelData.value.member_count --
          }

          // 显示中奖结果
          Toast(`恭喜您获得${playResult.value.content + (playResult.value.type == 2 ? '元现金' : '')}`)
          return
        }
      }

      // 更新当前选中的奖品（顺时针方向）
      currentOrderIndex = (currentOrderIndex + 1) % clockwiseOrder.length;
      currentPrizeIndex.value = clockwiseOrder[currentOrderIndex];
    }, 100);
  } else {
    Toast.fail(msg)
  }
};

// 组件销毁时清除定时器
onBeforeUnmount(() => {
  if (timer.value) {
    clearInterval(timer.value);
  }
});

// 抽奖记录数据
const records = ref([]);

// const mock = [
//   { username: 'nnlzh666', type: 2, content: '88888.88', created_at: '2025-03-28 10:51:28' },
//   { username: 'nnlzh666', type: 2, content: '8888.88', created_at: '2025-03-28 10:51:28' },
//   { username: 'nnlzh666', type: 2, content: '888.88', created_at: '2025-03-28 10:51:28' },
//   { username: 'nnlzh666', type: 2, content: '88.88', created_at: '2025-03-28 10:51:28' },
//   { username: 'nnlzh666', type: 2, content: '38.88', created_at: '2025-03-28 10:51:28' },
//   { username: 'nnlzh666', type: 2, content: '8.88', created_at: '2025-03-28 10:51:28' },
//   { username: 'nnlzh666', type: 1, content: '1.88', created_at: '2025-03-28 10:51:28' },
// ]

const loadingMore = ref(false);
const finishedMore = ref(false);
const currentPage = ref(1);
const totalPageCount = ref(0);
const showRecordPopup = ref(false);

const getPlayHistory = () => {
  const params = {
    pageSize: 20,
    page: currentPage.value
  }
  luckyWheelPlayHistory(params).then(res => {
    if (res.result === 200000) {
      loadingMore.value = false

      const data = res.data.list.data
      data.forEach(item => {
        const time = new Date(item.created_at).getTime()
        item.created_at = formatTime(time)
      })

      records.value = records.value.concat(data);

      totalPageCount.value = res.data.list.pageCount
      if(currentPage.value >= totalPageCount.value) {
        finishedMore.value = true
      }

      // records.value = mock;

    }
  })
}

watch(() => showRecordPopup.value, val => {
  if (val) {
    currentPage.value = 1;
    records.value = [];
    finishedMore.value = false;
    getPlayHistory();
  }
})

const onLoadMore = () => {
  if(currentPage.value >= totalPageCount.value) return;

  currentPage.value++
  getPlayHistory()
};

</script>

<style lang="less" scoped>
.lucky-wheel-container {
  min-height: 100vh;
  background-color: #E84435;
  padding-bottom: 20px;
  padding-top: 10px;
  background-image: url('../../assets/images/luckyWheel/topBg.png');
  background-repeat: no-repeat;
  background-size: 100% auto;

  // 导航栏样式
  .nav-bar {
    background-color: transparent;
    color: #FFFFFF;

    &::after {
        border: none;
    }

    :deep(.van-nav-bar__title) {
      color: #FFFFFF;
      font-weight: bold;
    }

    :deep(.van-icon) {
      //color: #FFFFFF;
    }

    :deep(.van-nav-bar__right) {
      padding-right: 0;
    }

    .logo {
      height: 39px;
    }

    .record-btn {
      width: 88px;
      height: 32px;
      color: #BE1302;
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 15px;
      line-height: 32px;
      letter-spacing: 0;
      background: #FFF0A7;
      border-radius: 20px 0 0 20px;
    }
  }

  // 主标题样式
  .main-title {
    text-align: center;
    color: #FFFFFF;

    .big-title {
      width: 277px;
      margin-bottom: 6px;
      margin-top: 6px;
    }

    .subtitle {
      margin-bottom: 8px;
      font-family: FZZhengHeiS-EB-GB;
      font-weight: bold;
      font-size: 18.97px;
      line-height: 100%;
      letter-spacing: 1.53px;
      text-align: center;
      color: #FAD835;
      /* 先定义一个浅色文本，再加深色阴影实现边框效果 */
      text-shadow:
        /* 多层阴影，模拟立体边框 */
            -1px -1px 0 #7B2F00,
            1px -1px 0 #7B2F00,
          -1px 1px 0 #7B2F00,
          1px 1px 0 #7B2F00,
            /* 再加多层阴影增加立体感 */
            //-2px -2px 0 #7B2F00,
            //2px -2px 0 #7B2F00,
          //-2px 2px 0 #7B2F00,
          0px 2px 0 #7B2F00;
    }


    .records-info {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 281px;
      height: 44px;
      margin: 5px auto 0;
      background: url('../../assets/images/luckyWheel/marqueeBg.png') center /100% 100%;
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 15px;
      line-height: 15px;
      letter-spacing: 0;
      text-align: center;
      color: #BE1302;

      .records-info-inner {
        width: 281px;
        height: 40px;
        overflow: hidden;
      }
    }
  }

  // 转盘容器样式
  .wheel-container {
    width: 352px;
    height: 443px;
    margin: 15px auto;
    //padding: 15px;
    padding-top: 40px;
    background-image: url('../../assets/images/luckyWheel/prizeBigBg.png');
    background-size: 100% 100%;

    .wheel-wrapper {
      position: relative;
      width: 320px;
      height: 383px;
      background-image: url('../../assets/images/luckyWheel/prizeBg.png');
      background-size: 100% 100%;
      margin: auto;

      .wheel-prizes {
        position: absolute;
        top: 46px;
        left: 50%;
        transform: translateX(-50%);
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: repeat(3, 1fr);
        gap: 4px;
        width: 224px;
        height: 194px;
        border-radius: 10px;

        .prize-item {
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          width: 72px;
          height: 62px;
          transition: all 0.3s;
          background: radial-gradient(50% 50% at 50% 50%, #FFFCCE 70.5%, #FFE983 100%);
          border-radius: 6px;

          &.center-item {
            background: radial-gradient(50% 50% at 50% 50%, #FE8977 70.5%, #F25B45 100%);
          }

          &.prize-active {
            transform: scale(1.05);
            background: radial-gradient(50% 50% at 50% 50%, #FDE25E 70.5%, #FDE25E 100%);
            border: 3px solid #FFC300!important;
          }

          .prize-content {
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;

            .prize-amount {
              font-family: PingFang SC;
              font-weight: 500;
              font-size: 12px;
              line-height: 12px;
              letter-spacing: 0;
              text-align: center;
              color: #7E0100;
            }

            .coin-icon {
              width: 41px;
              height: 24px;
              margin-bottom: 8px;
            }

            .prize-text {
              font-family: PingFang SC;
              font-weight: 500;
              font-size: 12px;
              line-height: 12px;
              letter-spacing: 0px;
              text-align: center;
              color: #7B0B00;

              > div {
                &:first-of-type {
                  margin-bottom: 6px;
                }
              }

              span {
                font-family: PingFang SC;
                font-weight: 500;
                font-size: 18px;
                line-height: 18px;
                letter-spacing: 0;
                color: #FFFB00;
              }
            }
          }
        }
      }

      // 中间的抽奖按钮
      .draw-button {
        position: absolute;
        bottom: 29px;
        left: 50%;
        transform: translateX(-50%);
        width: 81px;
        height: 81px;
        background: url('../../assets/images/luckyWheel/playIcon.png') no-repeat center;
        background-size: 100% 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #FFFFFF;
        font-weight: bold;
        font-size: 18px;
        cursor: pointer;
        z-index: 10;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
        transition: all 0.3s ease;

        &:active {
          transform: translateX(-50%) scale(0.92);
          filter: brightness(1.1);
        }
      }
    }
  }

  // 规则说明样式
  .rules-container {
    width: 350px;
    height: 388px;
    margin: auto;
    background: url('../../assets/images/luckyWheel/rulesBg.png') center/ 100% 100%;
    padding: 38px 12px 0;
    color: #FFFFFF;

    .rules-title {
      position: relative;
      margin-bottom: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      font-size: 22px;
      line-height: 22px;
      letter-spacing: 0;
      text-align: center;
      color: #FFE066;

      &::before {
        content: '';
        display: inline-block;
        width: 30px;
        height: 14px;
        margin-right: 8px;
        background: url('../../assets/images/luckyWheel/titleLeft.png') no-repeat center;
      }

      &::after {
        content: '';
        display: inline-block;
        width: 30px;
        height: 14px;
        margin-left: 8px;
        background: url('../../assets/images/luckyWheel/titleRight.png') no-repeat center;
      }
    }

    .rules-content {
      p {
        margin: 0 0 9px;
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 13px;
        line-height: 14px;
        letter-spacing: 0;
        text-align: center;
        color: #FFF;
      }

      .tips {
        margin-bottom: 51px;
        font-family: PingFang SC;
        font-weight: 500;
        font-size: 16px;
        line-height: 16px;
        letter-spacing: 0;
        text-align: center;
        color: #FFF7D3;
      }
    }
  }
}
:deep(.record-dialog) {
  width: 343px;
  height: 436px;
  border-radius: 12px;
  background: #FFF0A7;

  .van-dialog__header {
    padding: 15px 0 18px;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 18px;
    line-height: 18px;
    letter-spacing: 0px;
    text-align: center;
    color: #BE1302;
  }

  .table-header {
    display: flex;
    width: 100%;
    margin-bottom: 10px;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
    letter-spacing: 0;
    color: #BE1302;

    span {
      flex: 1;
      text-align: center;
    }

  }

    .record-list {
      max-height: 350px;
      overflow-y: auto;

      .record-item {
        display: flex;
        align-items: center;
        color: #850000;
        font-size: 14px;
        margin-bottom: 12px;
        //padding: 0 12px;

        span {
          flex: 1;
          text-align: center;
          font-family: PingFang SC;
          font-weight: 500;
          font-size: 12px;
          line-height: 12px;
          letter-spacing: 0;
          color: #850000;
          white-space: nowrap;
        }

        .username {
          //margin-left: 12px;
          text-align: center;
          //flex: 1.5;
        }
      }
    }

  .van-empty__description, .van-list__finished-text, .van-loading__text, .van-loading__spinner {
    color: #BE1302;
  }
}
</style>
